import '../styles/application.css'
import { createApp, h, DefineComponent } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'

createInertiaApp({
    resolve: (name) => {
        const pages = import.meta.glob('../pages/**/*.vue', { eager: true })
        const page = pages[`../pages/${name}.vue`] as { default: DefineComponent }
        return page.default
    },
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .mount(el)
    },
    progress: {
        color: '#4B5563',
        showSpinner: true,
    },
}) 